import { Flex, Paper, Title, Image, Box } from "@mantine/core";
import { ColorSchemeToggle } from "../ColorSchemeToggle/ColorSchemeToggle";
import AIChatButtonNewChat from "../AIChatButtonNewChat/AIChatButtonNewChat";
import styles from "./AIChatTitlebar.module.css";

interface AIChatTitlebarProps {
	appTitle: string;
	appTitleImageURL: string;
	showColorSchemeToggle: boolean;
	isReady: boolean;
	setThread: (thread: any) => void;
}

export default function AIChatTitlebar({
	appTitle,
	appTitleImageURL,
	showColorSchemeToggle,
	isReady,
	setThread,
}: AIChatTitlebarProps) {
	return (
		<Paper className={styles.root} p="sm" shadow="xs">
			<Flex align="center">
				<AIChatButtonNewChat setThread={setThread} isReady={isReady} />
				{appTitleImageURL !== "" ? (
					<Box className={styles.titleBox}>
						<Image
							className={styles.titleImage}
							src={appTitleImageURL}
							alt={appTitle}
							pl="md"
							pr="md"
							m="0 auto"
						/>
					</Box>
				) : (
					<Title size="h4" p="0" pl="md" pr="md" lineClamp={1} className={styles.title}>
						{appTitle}
					</Title>
				)}
				{showColorSchemeToggle && <ColorSchemeToggle />}
			</Flex>
		</Paper>
	);
}
